// 滚动条美化插件
// https://github.com/inuyaksa/jquery.nicescroll
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import PerfectScrollbar from 'perfect-scrollbar'

// 美化滚动条
Vue.directive('perfectScrollbar', {
  inserted (el, binding) {
    if (binding.modifiers.relative) {
      el.style.position = 'relative'
    }
    return new PerfectScrollbar(el, binding.value)
  },
})



// WEBPACK FOOTER //
// ./src/directive/perfect-scrollbar.js